<template>
  <div class="o-card u-padding-xsmall">
    <div class="u-display-flex u-align-items-center">
      <div class="u-display-none-sm-down">
        <img
          :src="require(`@/assets/images/battery-types/${battery.type}.png`)"
          :alt="battery.name"
          width="60"
        />
      </div>
      <div class="u-margin-left-small u-width-100%">
        <h4>{{ battery.name }}</h4>
        <div
          class="u-color-muted u-display-flex u-align-items-center u-justify-content-space-between u-margin-top-xsmall"
        >
          <span> {{ battery.type }}</span>
          <div>
            <Button
              v-if="battery.isPermission"
              @click="creatingPdf = true"
              class="u-margin-right-xsmall"
              variant="light-danger"
              >{{ $t("common.print") }}</Button
            >
            <Button
              v-if="battery.isPermission"
              @click="TO_THE_ID('changed-logs')"
              class="u-margin-right-xsmall"
              variant="light-primary"
              >{{ $t("common.records") }}</Button
            >
            <component
              :is="
                battery.isPermission && !battery.isLocked
                  ? 'router-link'
                  : 'span'
              "
              :to="`/batteries/${battery.id}/edit`"
            >
              <Button
                :disabled="!battery.isPermission || battery.isLocked"
                size="sm"
                variant="light-warning"
              >
                <i
                  :class="`icofont-${
                    battery.isPermission && !battery.isLocked
                      ? 'edit-alt'
                      : 'ui-lock'
                  }`"
                ></i>
                {{ $t("common.edit") }}
              </Button>
            </component>
          </div>
        </div>
      </div>
    </div>
    <div class="u-border-top u-margin-top-xsmall row u-padding-0">
      <div
        class="es-xs-12 es-sm-4 es-md-4 es-lg-4 u-border-right u-padding-left-xsmall"
      >
        <p class="u-color-muted">
          <small>
            <i class="icofont-user"></i>
            {{ $t("batteryDetail.userInfo") }}</small
          >
        </p>
        <h5 class="u-margin-top-xsmall u-color-primary">
          {{ battery.userInfo.fullname }}
        </h5>
      </div>
      <div
        class="es-xs-12 es-sm-4 es-lg-4 u-border-right u-padding-left-xsmall"
      >
        <p class="u-color-muted">
          <small>
            <i class="icofont-calendar"></i>
            {{ $t("batteryDetail.createdAt") }}</small
          >
        </p>
        <h5 class="u-margin-top-xsmall u-color-primary">
          {{ $date.format(battery.createdAt) }}
        </h5>
      </div>
      <div class="es-xs-12 es-sm-4 es-lg-4 u-padding-left-xsmall">
        <p class="u-color-muted">
          <small>
            <i class="icofont-calendar"></i>
            {{ $t("batteryDetail.updatedAt") }}</small
          >
        </p>
        <h5 class="u-margin-top-xsmall u-color-primary">
          {{ $date.format(battery.updatedAt) }}
        </h5>
      </div>
    </div>
    <EvaporatorBatteryInfo
      v-if="creatingPdf"
      @pdf-created-link="pdfCreatedLink"
      :project="{ evaporatorBatteryId: battery }"
    ></EvaporatorBatteryInfo>
  </div>
</template>

<script>
import Button from "../Base/Button.vue";
import EvaporatorBatteryInfo from "../FileManager/Pdfs/EvaporatorBatteryInfo.vue";
export default {
  components: {
    Button,
    EvaporatorBatteryInfo,
  },
  data() {
    return {
      creatingPdf: false,
    };
  },
  props: {
    battery: {
      default: () => ({}),
    },
  },
  methods: {
    pdfCreatedLink(url) {
      window.open(url, "_blank");
      this.creatingPdf = false;
    },
    TO_THE_ID(id) {
      this.$router.push({ query: { tab: "changedLogs" } });
      setTimeout(() => {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      }, 250);
    },
  },
};
</script>

<style></style>
